import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import NewsletterSignUp from "features/home/components/NewsletterSignUp";
import type { ResolvedSignupSection } from "resolvers/data/signupSectionResolver";
import styles from "./FooterSubscribeSection.module.scss";

const cx = classNames.bind(styles);

const FooterSubscribeSection = ({ image, form }: ResolvedSignupSection) => {
    return (
        <div className={cx("container")}>
            <div className={cx("imageWrapper")}>
                <Image
                    {...image}
                    alt={image?.alt ?? ""}
                    layout="fill"
                    objectFit="cover"
                    className={cx("image")}
                />
            </div>
            <div className={cx("contentWrapper")}>
                <NewsletterSignUp {...form} className={cx("signupForm")} />
            </div>
        </div>
    );
};

export default FooterSubscribeSection;
